import { WaitlistForm } from "./WaitlistForm";
import { LintMood } from "./LintMood";

export function FinalCta() {
  return (
    <section id="waitlist" className="scroll-mt-8 bg-surface-elevated py-20 sm:py-28" data-testid="final-cta">
      <div className="mx-auto grid max-w-5xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr]">
        <LintMood
          from="hero"
          to="books"
          alt="Lint leaning on a stack of books"
          dark
          say={["Still thinking it over?", "Bring me your idea. We'll ask the right questions together."]}
          bubbleClass="max-w-[240px]"
          className="w-56 sm:w-64"
          testId="final-cta-lint"
        />
        <div className="min-w-0 text-center lg:text-left">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-navy sm:text-5xl">
            You don&apos;t need to become a CTO.
          </h2>
          <p className="font-display mt-3 text-xl italic text-ink-muted sm:text-2xl">
            You just need Lint in your corner.
          </p>
          <p className="mt-4 text-sm text-ink-muted">
            Book a 30-minute demo and watch Lint review a real project.
          </p>
          <div className="mt-8">
            <WaitlistForm variant="footer" className="lg:mx-0" />
          </div>
        </div>
      </div>
    </section>
  );
}
